// Chakra imports
import {
  Skeleton,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Flex,
  Icon,
  Text,
} from "@chakra-ui/react";
import { MdLocationOn, MdEvStation } from "react-icons/md";
import React, { useState } from "react";
import { useEffect } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { useLocation, useNavigate } from "react-router-dom";

import { deleteModalState } from "atoms/deleteModalState";
import {
  stationTableHeaders,
  stationTableRoamingHeaders,
  tableHeaders,
} from "./variables/tableHeaders";
import StationsTable from "./components/StationsTable";
import LocationsTable from "./components/LocationsTable";
import LoadingSpinner from "components/feedback/LoadingSpinner";
import { loggedInUserState } from "atoms/loggedInUserState";

const loadingData = [
  {
    Name: <Skeleton />,
    PinCode: <LoadingSpinner />,
    PhoneNumber: <LoadingSpinner />,
  },
];
const ChargersList = () => {
  const setDeleteModal = useSetRecoilState(deleteModalState);
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const loggerInUser = useRecoilValue(loggedInUserState);

  const location = useLocation();
  const navigation = useNavigate();
  useEffect(() => {
    setDeleteModal(false);
  }, []);

  const clickHandler = (x) => {
    if (x === 0) {
      navigation(`/admin/locations`);
    } else if (x === 1) {
      navigation(`/admin/locations/stations`);
    }
  };

  useEffect(() => {
    if (location.pathname === "/admin/locations") {
      setActiveTabIndex(0);
    } else if (location.pathname === "/admin/locations/stations") {
      setActiveTabIndex(1);
    }
  }, [location]);

  return (
    <Tabs
      variant="unstyled"
      isLazy={true}
      index={activeTabIndex}
      style={{ marginTop: "20px" }}
    >
      <TabList
        gap={4}
        px={1}
        py={2}
        bg="rgba(255, 255, 255, 0.6)"
        backdropFilter="blur(12px)"
        borderRadius="xl"
        border="1px solid rgba(245, 125, 54, 0.15)"
        position="relative"
        overflow="hidden"
        _before={{
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "100%",
          zIndex: 0,
          pointerEvents: "none",
        }}
      >
        <Tab
          _focus={{ boxShadow: "none" }}
          onClick={() => clickHandler(0)}
          borderRadius="lg"
          px={5}
          py={2.5}
          fontWeight="500"
          color="gray.600"
          position="relative"
          zIndex="1"
          _selected={{
            bg: "rgba(245, 125, 54, 0.15)",
            color: "#f57d36",
            fontWeight: "600",
            boxShadow: "0 2px 4px rgba(245, 125, 54, 0.1)",
          }}
          _hover={{
            bg: "rgba(245, 125, 54, 0.08)",
            color: "#f57d36",
          }}
        >
          <Flex align="center" gap={2}>
            <Icon as={MdLocationOn} boxSize={5} />
            <Text>Locations</Text>
          </Flex>
        </Tab>
        <Tab
          _focus={{ boxShadow: "none" }}
          onClick={() => clickHandler(1)}
          borderRadius="lg"
          px={5}
          py={2.5}
          fontWeight="500"
          color="gray.600"
          position="relative"
          zIndex="1"
          _selected={{
            bg: "rgba(245, 125, 54, 0.15)",
            color: "#f57d36",
            fontWeight: "600",
            boxShadow: "0 2px 4px rgba(245, 125, 54, 0.1)",
          }}
          _hover={{
            bg: "rgba(245, 125, 54, 0.08)",
            color: "#f57d36",
          }}
        >
          <Flex align="center" gap={2}>
            <Icon as={MdEvStation} boxSize={5} />
            <Text>Chargers</Text>
          </Flex>
        </Tab>
      </TabList>
      <TabPanels>
        <TabPanel>
          <LocationsTable
            columnsData={
              loggerInUser?.role === "uadmin"
                ? stationTableRoamingHeaders
                : stationTableHeaders
            }
          />
        </TabPanel>
        <TabPanel>
          <StationsTable columnsData={tableHeaders} />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
};

export default ChargersList;
